import isReadingPaneCardUIEnabled from 'owa-mail-feature-flags/lib/isReadingPaneCardUIEnabled';

const FULL_COMPOSE_TOP_DOCKING_HEIGHT = 10;
const INLINE_COMPOSE_TOP_DOCKING_HEIGHT_NO_CARD_VIEW = 6;
const INLINE_COMPOSE_TOP_DOCKING_HEIGHT = 0;
const RIBBON_HEIGHT = 48;
const TOOLBAR_HEIGHT = 49;
const TOOLBAR_HEIGHT_NO_CARD_VIEW = 56;

export function getTopDockingHeight(isInlineCompose: boolean): number {
    return isInlineCompose
        ? isReadingPaneCardUIEnabled()
            ? INLINE_COMPOSE_TOP_DOCKING_HEIGHT
            : INLINE_COMPOSE_TOP_DOCKING_HEIGHT_NO_CARD_VIEW
        : FULL_COMPOSE_TOP_DOCKING_HEIGHT;
}

export function getBottomDockingHeight(isRibbonShown: boolean, isInlineCompose: boolean): number {
    const isCardUI = isInlineCompose && isReadingPaneCardUIEnabled();
    return (
        (isCardUI ? TOOLBAR_HEIGHT : TOOLBAR_HEIGHT_NO_CARD_VIEW) +
        (isRibbonShown ? RIBBON_HEIGHT : 0)
    );
}
